import type { ITradeIn } from '@makemydeal/dr-platform-types';
import { TRADE_SUMMARY, TRADE_MANUAL_ENTRY } from '@makemydeal/dr-activities-tradein';
import { AMOUNT_OWED_SOURCE_PLACEHOLDER, TRADE_PAYOFF_SOURCE } from '../constants';

export const tradeInPayloadHelpers = (state: any, selectors: any, isLoanFlowEnabled = false) => {
    const tradeInComponent = selectors.getTradeInComponent(state);
    if (!tradeInComponent) {
        return {} as ITradeIn;
    }
    const tradein = Object.keys(tradeInComponent).length;
    const isTradeCompleted = selectors.isTradeInCompleted(state);

    if (!tradein || !isTradeCompleted) {
        return {} as ITradeIn;
    }
    const tradeIn = selectors.getTradeInForOffer(tradeInComponent) as ITradeIn;

    // Handle case where getTradeInForOffer returns null or undefined
    if (!tradeIn) {
        return {} as ITradeIn;
    }
    tradeIn.lienHolderAddress = selectors.getLienHolderAddress(state) ?? {};
    tradeIn.lienHolderAccountNumber = selectors.getLienHolderAccountNumber(state);
    tradeIn.lienHolderPhoneNumber = selectors.getLienHolderPhoneNumber(state);
    tradeIn.zip = selectors.additionalSelectors.offerSelectors.getShopperZip(state);

    if (isLoanFlowEnabled) {
        const lenderName = tradeInComponent.amountOwedSource;
        if (lenderName && lenderName !== AMOUNT_OWED_SOURCE_PLACEHOLDER) {
            tradeIn.lienHolder = lenderName;
            tradeIn.amountOwedSource = TRADE_PAYOFF_SOURCE.DEALER;
        } else if (tradeIn.amountOwed > 0) {
            tradeIn.amountOwedSource = TRADE_PAYOFF_SOURCE.CONSUMER;
        }
    }

    return tradeIn;
};

export const getTradeInCompletionStatus = (currentRoute?: string, value?: number): boolean => {
    // Consider completed if:
    // 1. On trade summary with value (normal estimation flow)
    // 2. On manual entry with value (submit for appraisal flow - user filled the form)
    const isOnCompletionRoute = currentRoute === TRADE_SUMMARY || currentRoute === TRADE_MANUAL_ENTRY;
    return isOnCompletionRoute && value != null;
};
